import { MaterialMasterPage } from "./material-master-page"

// Material suppliers - the parties the company buys material from. Distinct
// from the `vendors` master, which is the subcontractor a PO is raised against.
// Bank, UPI and QR details live here so a Material Arrangement can prefill
// payment details rather than have them re-typed on every purchase.
export default function SuppliersPage() {
  return (
    <MaterialMasterPage
      config={{
        title: "Suppliers",
        endpoint: "suppliers",
        resource: "MaterialSupplier",
        primaryLabel: "supplier_name",
        columns: [
          { key: "supplier_code", label: "Code" },
          { key: "supplier_name", label: "Name" },
          { key: "contact_person", label: "Contact" },
          { key: "contact_number", label: "Phone" },
          { key: "city", label: "City" },
          { key: "gst_number", label: "GST" },
          { key: "is_active", label: "Active" },
        ],
        fields: [
          { name: "supplier_name", label: "Supplier Name", type: "text" },
          { name: "contact_person", label: "Contact Person", type: "text" },
          { name: "contact_number", label: "Contact Number", type: "text" },
          { name: "email", label: "Email", type: "text" },
          { name: "address", label: "Address", type: "textarea" },
          { name: "city", label: "City", type: "text" },
          { name: "state", label: "State", type: "text" },
          { name: "pincode", label: "Pincode", type: "text" },
          { name: "gst_number", label: "GST Number", type: "text" },
          { name: "pan_number", label: "PAN Number", type: "text" },
          { name: "bank_name", label: "Bank Name", type: "text" },
          { name: "account_number", label: "Account Number", type: "text" },
          { name: "ifsc_code", label: "IFSC Code", type: "text" },
          { name: "upi_id", label: "UPI ID", type: "text" },
          { name: "credit_days", label: "Credit Days", type: "number" },
          { name: "remarks", label: "Remarks", type: "textarea" },
          { name: "is_active", label: "Active", type: "checkbox" },
        ],
      }}
    />
  )
}
